/**
 * BB-6L -- agent-facing copy for Campaign Logout refusals.
 *
 * Mirrors `callLifecycleCopy.js`/`presenceFailureCopy.js`: the backend
 * returns a bounded machine code, and exactly one place turns it into a
 * sentence. Unknown and absent codes both fall through to the same
 * neutral message rather than rendering a raw enum at an agent.
 *
 * The refusals matter because each has a different remedy: a connected
 * call has to be ended first, a wrap-up has to be dispositioned, and a
 * provider outage just has to be retried.
 */

const LOGOUT_REFUSAL_COPY = Object.freeze({
  owned_call_connected: "Finish the current call before logging out of the campaign.",
  acquisition_in_progress: "A call is being connected. Try again in a moment.",
  hangup_in_progress: "The call is still hanging up. Try again in a moment.",
  wrap_up_pending: "Complete wrap-up before logging out of the campaign.",
  wrong_campaign: "You are logged into a different campaign. Refresh and try again.",
  lease_lost: "This session was taken over elsewhere. Refresh to continue.",
  not_configured: "Campaign logout is temporarily unavailable.",
  provider_unavailable: "The dialer is not responding. Try again in a moment.",
  native_refused: "The dialer did not complete the logout. Try again in a moment.",
  conf_exten_unavailable: "The dialer session is incomplete. Try again in a moment.",
  session_context_unavailable: "The dialer session could not be verified. Try again.",
  credential_unavailable: "The dialer session could not be verified. Try again.",
});

export function logoutRefusalMessage(outcome) {
  return (
    LOGOUT_REFUSAL_COPY[outcome] ||
    "Campaign logout could not be completed. Try again in a moment."
  );
}

export default logoutRefusalMessage;
